export const method = {
    labels: {},
    texts: {
        add_method: "Add Method",
        edit_method: "Edit Method",
        del_method: "Delete Method",
        del_confirm: "Do you want to delete the <strong>'{concat}'</strong> method?",
    },
};